<template>
  <div class="q-pb-lg">
    <div v-if="loading" class="q-mt-md row justify-center">
      <SAISpinner />
    </div>
    <QCarousel
      v-else
      class="full-height"
      v-model="carouselIndex"
      swipeable
      animated
      transition-prev="slide-right"
      transition-next="slide-left"
      :padding="false"
    >
      <QCarouselSlide
        :name="index"
        v-for="(group, index) in leaseGroups"
        :key="index"
        class="q-pa-none"
      >
        <div
          :class="[
            'row q-col-gutter-x-md q-pl-md justify-between',
            { 'q-pr-md': lastActive }
          ]"
        >
          <div
            v-for="(lease, index) in group"
            :key="index"
            :class="isMobile || group.length > 1 ? 'col' : 'col-6'"
          >
            <LeaseCard
              v-if="lease.id"
              class="col"
              :month-savings="lease.savingsGSTThisMonth"
              :gst-saving-to-date="lease.savingsToDateGST"
              :tax-saving-to-date="lease.savingsToDateTax"
              :img="lease.vehicleImg"
              :rego="lease.vehicleRego"
              :term="lease.term"
              :current-month="lease.currentMonth"
              :current-balance="lease.currentBalance"
              @open:lease="$emit('open:lease', lease)"
              @open:budget="$emit('open:budget', lease)"
            />
            <LeaseWithoutDataCard
              v-else
              class="col"
              :title="lease.vehicleTitle"
              :contact-number="lease.contactNumber"
              :img="leaseWithoutDataImg"
            />
          </div>
          <PreviewCard v-if="!lastActive" :is-mobile="isMobile" />
        </div>
      </QCarouselSlide>
    </QCarousel>
    <SAICarouselNavigation
      v-if="!loading"
      :dots="dots"
      class="q-mt-lg q-px-md"
      :infinite="false"
      @input="carouselIndex = $event.index"
    />
  </div>
</template>

<script>
import { QCarousel, QCarouselSlide } from 'quasar';
import { SAICarouselNavigation, SAISpinner } from 'ecx.saigon.ui.common';

export default {
  name: 'LeaseStepper',
  props: {
    isMobile: Boolean,
    leaseWithoutDataImg: String,
    leaseGroups: {
      type: Array,
      default: () => []
    },
    loading: Boolean
  },
  data() {
    return {
      carouselIndex: 0
    };
  },
  watch: {
    isMobile() {
      this.carouselIndex = 0;
    },
    leaseGroups: {
      immediate: true,
      handler(value = []) {
        if (!value || !value[this.carouselIndex]) {
          this.carouselIndex = 0;
        }
      }
    }
  },
  computed: {
    dots() {
      return this.leaseGroups.map((group, index) => ({
        index,
        active: index === this.carouselIndex
      }));
    },
    lastActive() {
      return this.carouselIndex >= this.leaseGroups.length - 1;
    }
  },
  components: {
    QCarousel,
    QCarouselSlide,
    SAICarouselNavigation,
    SAISpinner,
    LeaseWithoutDataCard: () => import('../lease-without-data-card'),
    PreviewCard: () => import('../../atom/preview-card'),
    LeaseCard: () => import('../../organism/lease-card')
  }
};
</script>
